<section class="mb-20">
  <div class="mt-5 relative">
    <div
      class="w-full bg-[#285CA5] h-[124px] sm:h-[150px] rounded-t-xl flex items-center justify-end gap-3"
    >
      <div class="pr-4 sm:pr-8">
        <p class="text-white font-semibold text-base sm:text-xl">
          {{ greetingMessage }} {{ nurse?.name }}
        </p>
      </div>
    </div>
    <div class="w-full h-[124px] sm:h-[150px] flex items-center">
      <div class="ml-32 sm:ml-64 flex items-start justify-between w-full">
        <div>
          <div class="flex items-center space-x-3">
            <div
              class="w-[17px] h-[17px] rounded-full"
              [style.backgroundColor]="getServiceDurationColor()"
            ></div>
            <p class="text-lg sm:text-2xl font-bold m-0 text-[#000000A6]">
              {{ nurse?.name
              }}<span class="text-[#526ED3] text-sm sm:text-base font-medium">
                {{ getEmployeeDisplayNumber() }}</span
              >
            </p>
          </div>
          <p class="text-[#6B6D80] text-xs sm:text-sm font-medium m-0 pt-2">
            Registered on {{ nurse?.registrationDate | date : "MMM d, y" }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="w-[100px] h-[100px] sm:w-[180px] sm:h-[180px] rounded-full absolute top-16 md:top-10 left-4 sm:left-10"
    >
      <img
        class="object-cover w-full h-full rounded-full"
        src="{{ nurse?.profilePic }} "
        alt=""
      />
    </div>
  </div>
  <tui-tabs
    [(activeItemIndex)]="activeItemIndex"
    class="gap-2 sm:gap-5 text-sm sm:text-base overflow-x-auto"
  >
    <button tuiTab type="button">Attendance</button>
    <button tuiTab type="button">My Profile</button>
    <button tuiTab type="button">Leave Records</button>
    <button tuiTab type="button">Salary</button>
    <button tuiTab type="button">Security</button>
  </tui-tabs>

  <div class="mt-5" *ngIf="activeItemIndex === 0">
    <search
      class="w-full sm:w-[80%] lg:w-[50%] xl:w-[50%] 2xl:w-[40%] mb-5"
      tuiSearch
      style="padding-left: 0"
    >
      <fieldset
        class="border-none"
        tuiTextfieldSize="m"
        style="padding-left: 0"
      >
        <div
          class="flex flex-col sm:flex-row items-start sm:items-center sm:space-x-4 space-y-2 sm:space-y-0"
        >
          <div class="w-full sm:w-[431px]">
            <tui-input-date-range
              [(ngModel)]="dateRange"
              tuiUnfinishedValidator="Finish filling the field"
            >
              Date range filter
            </tui-input-date-range>
          </div>
          <div class="flex space-x-2">
            <button
              size="m"
              tuiButton
              type="button"
              (click)="onFilter()"
              class="px-4 sm:px-10"
            >
              Filter
            </button>

            <button
              type="button"
              tuiButton
              appearance="outline"
              (click)="resetFilter()"
            >
              Reset Filter
            </button>
          </div>
        </div>
      </fieldset>
    </search>
    <div *ngIf="upcomingShifts.length === 0">
      <p class="text-base font-medium text-[#3E4A58]">
        No Upcoming Shifts Available!
      </p>
    </div>
    <div class="flex overflow-x-auto">
      <div *ngIf="upcomingShifts.length > 0" class="w-full min-w-[750px]">
        <table tuiTable size="m" class="w-full">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Date
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Patient name
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Roster
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Meal Option
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Type
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Address
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Salary
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let shift of upcomingShifts">
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm cursor-pointer">
                    {{ getFormattedDate(shift.date) }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.client[0].name }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.rooster }} Hour
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.mealOption }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.shiftType }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{
                      (shift.address || "").length > 20
                        ? ((shift.address || "") | slice : 0 : 40) + "..."
                        : (shift.address || "")
                    }}
                  </p>
                </div>
              </td>
              <td
                tuiTd
                style="padding-left: 10px; padding-top: 0; padding-bottom: 0"
              >
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    LKR {{ shift.salary | number : "1.2-2" }}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="flex justify-end items-center mt-5">
      <tui-pagination
        [index]="upcomingShiftPageIndex - 1"
        [length]="getUpcomingShiftPageCount()"
        (indexChange)="onUpcomingShiftPageChange($event + 1)"
      >
      </tui-pagination>
    </div>
  </div>

  <div class="mt-5" *ngIf="activeItemIndex === 1">
    <div class="flex flex-col sm:flex-row">
      <div class="mb-4 sm:mb-0 sm:inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0">
          Personal Information
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0">
          View Nurse information
        </p>
      </div>
      <div class="sm:inline-block sm:pl-4 md:pl-[5.5rem]">
        <div>
          <p class="text-sm text-[#595959] font-medium my-0">Employee Number</p>
          <p class="text-[#6B6D80] text-xl font-bold my-0">
            {{ getEmployeeDisplayNumber() }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Email Address</p>
          <p class="text-[#285CA5] text-xl font-semibold my-0 break-words">
            {{ nurse?.email }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">
            Phone Number (Whatsapp)
          </p>
          <p class="text-[#285CA5] text-xl font-semibold my-0">
            {{ nurse?.contactNo }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Address</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0 break-words">
            {{ nurse?.address }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Date Of Birth</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ nurse?.dateOfBirth | date : "MMM d, y"  }} 
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Age</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ nurse?.age }} Years
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row mt-5">
      <div class="mb-4 sm:mb-0 sm:inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0">
          Client Details
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0">
          View Contact Person
        </p>
      </div>
      <div class="sm:inline-block sm:pl-4 md:pl-[7rem]">
        <div class="flex flex-col sm:flex-row sm:space-x-10 md:space-x-20">
          <div class="mb-4 sm:mb-0">
            <p class="text-sm text-[#595959] font-medium my-0">Name</p>
            <p class="text-[#1B1F3BA6] text-xl font-bold my-0">
              {{ nurse?.gurdianName }}
            </p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium my-0">Phone Number</p>
            <p class="text-[#285CA5] text-xl font-semibold my-0">
              {{ nurse?.gurdianContact }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row mt-8">
      <div class="mb-4 sm:mb-0 sm:inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0 w-[200px]">Notes</p>
        <p class="text-sm font-semibold text-[#949494D9] my-0 w-[200px]">
          View notes
        </p>
      </div>
      <div class="sm:inline-block sm:pl-4 md:pl-[45px] lg:pl-[3rem]">
        <div
          style="border: 1px solid #d1d5db; border-radius: 6px; padding: 16px"
        >
          <p
            class="text-[0.938rem] text-[#1B1F3BA6] font-medium my-0 w-full md:w-full lg:w-full xl:w-[760px] 2xl:w-[960px] h-full"
          >
            {{ nurse?.notes }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5" *ngIf="activeItemIndex === 2">
    <div class="flex items-center justify-between mb-4 flex-wrap gap-3">
      <p class="text-base font-medium text-[#3E4A58] m-0">Leave Records</p>
      <div class="flex items-center gap-3">
        <button tuiButton type="button" size="s" appearance="secondary" (click)="prevLeaveMonth()">Prev</button>
        <span class="text-sm font-semibold">{{ leaveMonthLabel }}</span>
        <button tuiButton type="button" size="s" appearance="secondary" (click)="nextLeaveMonth()">Next</button>
      </div>
    </div>

    <!-- Leave Summary Card above table -->
    <div class="mb-6 p-4 bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl flex flex-col gap-3" *ngIf="balance">
      <!-- Permanent Nurse Breakdown -->
      <ng-container *ngIf="balance.annualLeave?.eligible; else casualSummary">
        <div class="flex items-center gap-6 flex-wrap text-sm text-[#475569]">
          <span class="font-bold text-[#1E293B] min-w-[120px]">Day-offs:</span>
          <div>Entitled: <strong class="text-[#0F172A]">{{ balance.dayOffs?.entitled ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Used: <strong class="text-[#0F172A]">{{ balance.dayOffs?.used ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Remaining: <strong class="text-[#2563EB]">{{ balance.dayOffs?.remaining ?? 0 }}</strong></div>
        </div>
        <div class="flex items-center gap-6 flex-wrap text-sm text-[#475569]">
          <span class="font-bold text-[#1E293B] min-w-[120px]">Annual Leaves:</span>
          <div>Entitled: <strong class="text-[#0F172A]">{{ balance.annualLeave?.entitled ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Used: <strong class="text-[#0F172A]">{{ balance.annualLeave?.used ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Remaining: <strong class="text-[#2563EB]">{{ balance.annualLeave?.remaining ?? 0 }}</strong></div>
        </div>
      </ng-container>

      <!-- Casual Nurse Breakdown -->
      <ng-template #casualSummary>
        <div class="flex items-center gap-6 flex-wrap text-sm text-[#475569]">
          <span class="font-bold text-[#1E293B] min-w-[120px]">Day-offs:</span>
          <div>Available: <strong class="text-[#0F172A]">{{ availableCount }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Used: <strong class="text-[#0F172A]">{{ usedCount }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Remaining: <strong class="text-[#D97706]">{{ remainingCount }}</strong></div>
        </div>
        <div class="text-xs text-[#64748B]">
          Casual nurses — Day-Offs only (5 / month).
        </div>
      </ng-template>
    </div>

    <div *ngIf="leaveRecords.length === 0">
      <p class="text-base font-medium text-[#3E4A58]">No leave records for this month.</p>
    </div>
    <table *ngIf="leaveRecords.length > 0" tuiTable size="m" class="w-full">
      <thead>
        <tr>
          <th tuiTh style="background-color: #285ca5; color: white">Leave Type</th>
          <th tuiTh style="background-color: #285ca5; color: white">Submitted</th>
          <th tuiTh style="background-color: #285ca5; color: white">From - To</th>
          <th tuiTh style="background-color: #285ca5; color: white">Days</th>
          <th tuiTh style="background-color: #285ca5; color: white">Reason</th>
        </tr>
      </thead>
      <tbody tuiTbody>
        <tr *ngFor="let leave of leaveRecords">
          <td tuiTd>{{ leave.leaveType === 'AnnualLeave' ? 'Annual Leave' : 'Day-Off' }}</td>
          <td tuiTd>{{ leave.submittedDate | date : 'MMM d, y' }}</td>
          <td tuiTd>
            {{ leave.fromDate | date : 'MMM d, y' }}
            –
            {{ leave.toDate | date : 'MMM d, y' }}
          </td>
          <td tuiTd>{{ leave.dayCount }}</td>
          <td tuiTd>{{ leave.reason || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-5" *ngIf="activeItemIndex === 3">
    <div *ngIf="salaryRecords.length == 0">
      <p class="text-base font-medium text-[#3E4A58]">Salary Unavailable!</p>
    </div>

    <div *ngIf="salaryRecords.length > 0" class="flex overflow-x-auto">
      <div class="w-full xl:w-1/3 2xl:w-full">
        <table
          tuiTable
          size="m"
          class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]"
        >
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Month
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                No of Shifts
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Salary
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Actions
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let salaryRecord of salaryRecords">
              <td tuiTd style="padding: 0; padding-left: 10px;">
                <div tuiCell="m">
                  <p

                    class="text-[#526ED3] text-sm cursor-pointer"
                  >
                    {{ salaryRecord.monthName }} - {{ salaryRecord.year }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding: 0;padding-left: 10px;">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ salaryRecord.shifts.length }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding: 0;padding-left: 10px;">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ salaryRecord.totalSalary | number : "1.2-2" }} LKR
                  </p>
                </div>
              </td>
              <td tuiTd style="padding: 0;padding-left: 10px;">
                <div tuiCell="m">
                  <p
                    class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
                    (click)="
                      viewSalaryDetails(
                        nurseId,
                        salaryRecord.month,
                        salaryRecord.year
                      )
                    "
                  >
                    View Details
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="flex justify-start items-center mt-5 ml-[300px] md:ml-[570px] lg:ml-[450px] xl:ml-[690px] 2xl:ml-[970px]"
        >
          <tui-pagination
            [index]="salaryPageIndex - 1"
            [length]="getSalaryPageCount()"
            (indexChange)="onSalaryPageChange($event + 1)"
          >
          </tui-pagination>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-5" *ngIf="activeItemIndex === 4">
    <form [formGroup]="changePasswordForm" (ngSubmit)="submitChangePassword()">
      <div class="flex flex-col sm:flex-row">
        <div class="mb-4 sm:mb-0">
          <p class="text-base font-medium text-[#3E4A58] my-0">
            Nurse Information
          </p>
          <p class="text-sm font-normal text-[#949494D9] my-0 w-[225px]">
            Change password
          </p>
        </div>
        <div
          class="w-full sm:w-2/3 md:w-1/2 xl:w-1/3 2xl:w-1/3 sm:pl-4 md:pl-[6rem]"
        >
          <label tuiLabel class="tui-space_bottom-4">
            <tui-input-password formControlName="oldPassword">
              Old Password
              <input tuiTextfieldLegacy type="password" />
            </tui-input-password>
            <tui-error
              formControlName="oldPassword"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>

          <label tuiLabel class="tui-space_bottom-4">
            <tui-input-password formControlName="password">
              New Password
              <input tuiTextfieldLegacy type="password" />
            </tui-input-password>
            <tui-error
              formControlName="password"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>

          <label tuiLabel class="tui-space_bottom-4">
            <tui-input-password formControlName="confirmPassword">
              Confirm Password
              <input tuiTextfieldLegacy type="password" />
            </tui-input-password>
            <tui-error
              formControlName="confirmPassword"
              class="mb-3"
              [error]="[] | tuiFieldError | async"
            />
          </label>

          <div class="mt-5 space-x-5 flex justify-end">
            <button
              tuiButton
              [disabled]="isLoading"
              appearance="primary"
              size="m"
              type="submit"
            >
              Update Password
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
